// extracted by mini-css-extract-plugin
export default {"top-coverer":"styles_top-coverer__E4wxY"};